import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

export default function TotalAlerts({ filters, defaultData, chartsData, lastFilter, setLastFilter, data: data2, setData }) {
    const data = data2.filter(item => item.category !== "Machine Guard")
    const highSeverityItems = data?.filter(item =>
        item?.category === 'MMHE' || item?.category === 'Emergency Exit' || item?.category === 'No Go'
    );

    const mediumPlusItems = data?.filter(item =>
        item?.category === 'Helmet' || item?.category === 'Vest'
    );

    const mediumItems = data?.filter(item =>
        item?.category === 'Machine Guard'
    );

    // Step 2: Sort each group by value descending
    const sortedHighSeverity = [...highSeverityItems].sort((a, b) => b.value - a.value);
    const sortedMediumPlus = [...mediumPlusItems].sort((a, b) => b.value - a.value);

    // Step 3: Combine in the desired order
    const finalData = [...sortedHighSeverity, ...sortedMediumPlus, ...mediumItems];
    let newData = finalData;
    
    const categoryAbbreviations = {
        "Emergency Exit": "E. Exit",
        "MMHE": "MMHE",
        "Helmet": "Helmet",
        "Vest": "Vest",
        "Machine Guard": "M. Guard",
        "No Go" : "No Go"
    };
  
    const createSeries = () => {
        // Step 1: Group data
        const highSeverityItems = data?.filter(item =>
            item?.category === 'MMHE' || item?.category === 'Emergency Exit' || item?.category === 'No Go'
        );

        const mediumPlusItems = data?.filter(item =>
            item?.category === 'Helmet' || item?.category === 'Vest'
        );

        const mediumItems = data?.filter(item =>
            item?.category === 'Machine Guard'
        );

        // Step 2: Sort each group by value descending
        const sortedHighSeverity = [...highSeverityItems].sort((a, b) => b.value - a.value);
        const sortedMediumPlus = [...mediumPlusItems].sort((a, b) => b.value - a.value);

        // Step 3: Combine in the desired order
        const finalData = [...sortedHighSeverity, ...sortedMediumPlus, ...mediumItems];
        newData = finalData;
        console.log('datafff', data)
        console.log('finalDatafinalData', finalData)

        // Step 4: Build series
        return [
            {
                name: 'High Severity',
                data: finalData.map(item =>
                    (item?.category === 'MMHE' || item?.category === 'Emergency Exit' || item?.category === 'No Go')
                        ? item.value : 0),
                color: '#ef4343',
            },
            {
                name: 'Medium Plus Severity',
                data: finalData.map(item =>
                    (item?.category === 'Helmet' || item?.category === 'Vest')
                        ? item?.value : 0),
                color: '#f0ab43',
            },
            {
                name: 'Medium Severity',
                data: finalData.map(item =>
                    item?.category === 'Machine Guard'
                        ? item?.value : 0),
                color: '#40a1ff',
            },
        ];
    };





    const options = {
        chart: {
            type: 'bar',
            stacked: true,  // Stacked bars
            height: 350,
            toolbar: {
                show: false,
                export: {
                    csv: { enabled: false },
                    svg: { enabled: false },
                    png: { enabled: false },
                    print: { enabled: false },
                }
            },
        },
        
        dataLabels: {
            enabled: true,  // Enable data labels
            style: {
                colors: ['#ffffff'],  // Label color
                fontSize: '11px',  // Adjust font size
            },
            formatter: function (val, opts) {
                return `${val}`; // Show data value in labels
            },
            textAnchor: 'middle',
        },
        tooltip: {
            enabled: true,
            shared: true,  // Tooltip is shared across all series (columns)
            intersect: false,  // Show tooltip only on hover
            style: {
                fontSize: '12px',  // Tooltip text size
                fontWeight: 'normal',
            },
            x: {
                show: true,  // Show category name
                formatter: function (value) {
                    return `${value}`;  // Return category name
                },
            },
            y: {
                formatter: function (value, opts) {
                    // Get the data for the current category (across all series)
                    const seriesValues = opts.w.globals.series;
                    const categoryIndex = opts.dataPointIndex;  // Index for the current category
                    const isAllZero = seriesValues.every(series => series[categoryIndex] === 0 || series[categoryIndex] === null); // Check if all values for this category are 0 or null

                    // If all values are zero/null for this category, return 0%
                    if (isAllZero) {
                        return '0';  // Return 0% when all values for this category are zero or null
                    }
                    else {
                        // If the value is non-zero, show the value as percentage
                        if (value !== 0 && value !== null) {
                            return `${value}`;  // Format and return the value as percentage
                        }
                    }


                }
            }


        },
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadiusWhenStacked: 'all',
                columnWidth: '65%',
                distributed: false,  // Ensures each bar gets its assigned color
                borderRadiusApplication: 'around',
                borderRadius: 4,
            },
        },
        xaxis: {
            categories: newData?.map(item => categoryAbbreviations[item?.category] || item?.category),  // Categories for x-axis
            labels: {
                style: {
                    fontSize: '12px',  // Label font size
                },
                rotate: 0,
                hideOverlappingLabels: false,
                trim: true,  // Trim labels if they are too long
            },
        },
        yaxis: {
            title: {
                text: 'Alerts',
                style: {
                    lineHeight: '2.5',
                    fontSize: '13px',
                    fontWeight: '100',
                    fontFamily: 'sans-serif',
                },
            },
            labels: {
                style: {
                    fontSize: '12px',
                },
            },
            min: 0, // Ensure the min value starts at 0
            // max: Math.ceil(Math.max(...res?.data?.series.flatMap(s => s.data)) * 1.2), // Increase max limit
            forceNiceScale: true,
        },
        title: {
            text: 'Summary of Safety Behavior Observations',
            align: 'center',
            style: {
                fontSize: '14px',
                fontWeight: '500',
            },
        },
        fill: {
            opacity: 1,
        },
        legend: {
            show: true,
            position: 'bottom',  // Position the legend at the bottom
            horizontalAlign: 'center',
            labels: {
                useSeriesColors: false,  // Use the series colors
            },
            markers: {
                width: 12,
                height: 12,
                radius: 12,  // Circular markers for legend
            },
            formatter: function (val, opts) {
                if (opts?.seriesIndex === 0) return 'High Severity';  // Red
                if (opts?.seriesIndex === 1) return 'Medium Plus Severity';  // Yellow
                if (opts?.seriesIndex === 2) return 'Medium Severity';  // Blue
            },
        },
        responsive: [
            {
                breakpoint: 1367,
                options: {
                    chart: {
                        width: '100%',
                    },
                    xaxis: {
                        labels: {
                            style: {
                                fontSize: '12px',  // Adjust font size for smaller screens
                            },
                            rotate: -45,  // Rotate labels for better fit
                        },
                    },
                }
            },
            {
                breakpoint: 992,
                options: {
                    chart: {
                        height: 400,
                    },
                }
            },
            {
                breakpoint: 697,
                options: {
                    chart: {
                        width: '100%',
                    },
                    xaxis: {
                        labels: {
                            style: {
                                fontSize: '12px',  // Adjust font size for smaller screens
                            },
                            rotate: -45,  // Rotate labels for better fit
                        },
                    },
                }
            },
            {
                breakpoint: 620,
                options: {
                    chart: {
                        width: '100%',
                    },
                    xaxis: {
                        labels: {
                            style: {
                                fontSize: '10px',  // Adjust font size for smaller screens
                            },
                            rotate: -45,  // Rotate labels for better fit
                        },
                    },
                    dataLabels: {
                        style: {
                            fontSize: '9px',  // Adjust font size for readability
                        },
                    },
                }
            }
        ]
    };



    return (
        <>
            <ReactApexChart
                options={options}
                series={createSeries()} // Series based on updated data
                type="bar"
                height={options?.chart?.height}
            />
        </>
    );
}
